/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
if (document.querySelector('.PageContent')) {
  const loading = document.querySelector('.loading')
  const submitEmailList = localStorage.getItem('submitEmailList')
  const cartItems = document.querySelector('.PageContent form.Cart')
  const stimateShipping = document.querySelector('.PageContent .Section')
  if(submitEmailList === null) {
    loading.style.display = 'flex'
    cartItems.classList.add('hide')
    stimateShipping.classList.add('hide')
  }
  setTimeout(function(){
    const emailContainer = document.querySelector('.email-form')
    const inputEmail = document.querySelector('.klaviyo-form input[type=email]')
    const submitForm = document.querySelector('.klaviyo-form button')
    const checkPolicy = document.querySelector('.regular-checkbox')
    loading.style.display = 'none'
    if(inputEmail !== null) {
      console.log("Paso por aquí");
      if(submitEmailList === null) {
        emailContainer.classList.add('show')
        cartItems.classList.add('hide')
        stimateShipping.classList.add('hide')
        submitForm.disabled = true;
        checkPolicy.addEventListener('click', () => {
          submitForm.disabled = (checkPolicy.checked) ? false : true
        });
        submitForm.addEventListener('click', function() {
          const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if(pattern.test(String(inputEmail.value).toLowerCase()) && checkPolicy.checked) {
            emailContainer.classList.remove('show')
            cartItems.classList.remove('hide')
            stimateShipping.classList.remove('hide')
            localStorage.setItem('submitEmailList', true);
          }
        })
      } else {
        loading.style.display = 'none'
        emailContainer.classList.remove('show')
        cartItems.classList.remove('hide')
        stimateShipping.classList.remove('hide')
      }
    } else {
      loading.style.display = 'none'
      emailContainer.classList.remove('show')
      cartItems.classList.remove('hide')
      stimateShipping.classList.remove('hide')
    }
  }, 3000);
}



//fetchProductCollection()

setTimeout(function(){
  let translate = document.querySelector('.translation-lab-floating-dropdown-container')
  let headerRight = document.querySelector('#header-right')
  headerRight.append(translate)
}, 50);

if(window.location.pathname === '/') localStorage.setItem('translation-lab-lang', 'en')

let langSelect = localStorage.getItem('translation-lab-lang')
if(langSelect === null) localStorage.setItem('translation-lab-lang', 'en')
let langElements = document.querySelectorAll('*[data-lang]')

setTimeout(function(){
  if(langSelect === 'en'){
    let whishlist = document.querySelector('.swym-wishlist-cta')
    //console.log(whishlist);
    //whishlist.innerHTML = 'ADD TO YOUR WISHLIST'
  }
}, 1000);

if(langSelect === 'en') {
  document.querySelector('.Header__LogoLink').href = '/'
} else {
  document.querySelector('.Header__LogoLink').href = '/es'
}

langElements.forEach(el => {
  if(el.dataset.lang != langSelect) {
    console.log(el.dataset.lang);
    el.setAttribute('style', 'display: none !important');
  }
})

if (document.querySelector('.PageContainer main')) {

  let iconVideoURL = '//www.sesena.com/cdn/shop/t/9/assets/iconoplay.svg?v=44629226270600768521605784098'
  let contentVideoButton = document.querySelector('.pf-9ec5ad1f')
  let videoButton = document.createElement('div')
  videoButton.innerHTML = `<button>
    <img src="${iconVideoURL}" width="25px">
  </button>`
  videoButton.className = 'play-video'

  let modal = document.querySelector('.pf-ad1f611f .sc-pbYdQ:last-child')
  let closeModal = document.createElement('div')
  closeModal.innerHTML = '<span>X</span>'
  closeModal.className = 'close-modal'

  contentVideoButton.prepend(videoButton)
  modal.append(closeModal)

  videoButton.addEventListener("click", function () {
    modal.style.display = 'flex'
  });

  closeModal.addEventListener("click", function () {
    modal.style.display = 'none'
  });
  
}
